// extracted by mini-css-extract-plugin
export var eventDescription = "event-module--eventDescription--GXEfg";
export var sbShowMain = "event-module--sb-show-main--EFNtl";